module.exports = __webpack_public_path__ + "static/media/health-black-icon.d2675387.svg";